"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPositionStringToPosition = void 0;
const utils_1 = require("@daytrip/utils");
const Position_1 = require("../models/Position");
const transformPositionStringToPosition = (positionString) => {
    if ((0, utils_1.isUndefinedOrNull)(positionString)) {
        return undefined;
    }
    const [lat, long] = positionString.split(",");
    if (!lat || !long) {
        return undefined;
    }
    return new Position_1.Position(Number(lat), Number(long));
};
exports.transformPositionStringToPosition = transformPositionStringToPosition;
//# sourceMappingURL=transformPositionStringToPosition.js.map